export default
  "Déclaration d'accessibilité du site Solution Éco France — conformité partielle au RGAA 4.1 et WCAG 2.2 AA, audit interne mai 2026, plan d'amélioration et voies de recours.";
